import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import LandingPage from '@/pages/LandingPage';
import PilotClubPage from '@/pages/PilotClubPage';
import AdminPage from '@/pages/AdminPage';
import AdminPilotPage from '@/pages/AdminPilotPage';
import AdminActivityPage from '@/pages/AdminActivityPage';
import AdminAuditPage from '@/pages/AdminAuditPage';
import InvestorPackPage from '@/pages/InvestorPackPage';
import AdminDeletedPage from '@/pages/AdminDeletedPage';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/pilot-club" element={<PilotClubPage />} />
          <Route path="/admin/waitlist" element={<AdminPage />} />
          <Route path="/admin/pilot" element={<AdminPilotPage />} />
          <Route path="/admin/activity" element={<AdminActivityPage />} />
          <Route path="/admin/audit" element={<AdminAuditPage />} />
          <Route path="/admin/investor-pack" element={<InvestorPackPage />} />
          <Route path="/admin/deleted" element={<AdminDeletedPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
